import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Box, Accordion as Accordion$1, AccordionSummary, AccordionDetails } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import { ReactComponent as ForwardRef } from '../../assets/icons/ArrowDownSmall.svg.js';
import 'react';
import theme from '../../theme/theme.js';
import '../../theme/lightTheme.js';

const SummaryContainer = styled(Box) `
  display: flex;
  align-items: center;
  color: ${theme.palette.N20.main};
`;
const TitleContainer = styled('div') `
  padding: 8px 0px;
  user-select: text;
`;
const Accordion = ({ icon, label, children }) => (jsxs(Accordion$1, Object.assign({ disabled: !children }, { children: [jsx(AccordionSummary, Object.assign({ expandIcon: jsx(ForwardRef, { color: theme.palette.N30.main }), "data-testid": "accordion-summary", sx: { opacity: '1 !important' } }, { children: jsxs(SummaryContainer, { children: [icon && (jsx(Box, Object.assign({ "data-testid": "summary-icon", mr: 2 }, { children: icon }))), jsx(TitleContainer, { children: jsx(MuiTypography, Object.assign({ variant: "body1" }, { children: label })) })] }) })), children && jsx(AccordionDetails, Object.assign({ "data-testid": "details-content" }, { children: children }))] })));

export { Accordion as default };
//# sourceMappingURL=Accordion.js.map
